export const ONGOING_RESERVATION_STATUSES = [
  'verification',
  'staff_member_review',
  'preparing',
  'delivery_started',
  'delivery_finished',
  'ready_for_pickup',
] as const;

const FULFILLED_RESERVATION_STATUSES = [
  'finished',
  'with_review',
  'finished_without_review',
] as const;

const CANCELLED_RESERVATION_STATUSES = ['cancelled', 'dismissed'] as const;

export const FINAL_RESERVATION_STATUSES = [
  ...FULFILLED_RESERVATION_STATUSES,
  ...CANCELLED_RESERVATION_STATUSES,
] as const;

export type OngoingReservationStatus =
  (typeof ONGOING_RESERVATION_STATUSES)[number];

type FulfilledReservationStatus =
  (typeof FULFILLED_RESERVATION_STATUSES)[number];

type CancelledReservationStatus =
  (typeof CANCELLED_RESERVATION_STATUSES)[number];

type FinalReservationStatus = (typeof FINAL_RESERVATION_STATUSES)[number];

export type ReservationStatus =
  | OngoingReservationStatus
  | FinalReservationStatus
  | 'pending';

export const isOngoingReservationStatus = (
  status?: ReservationStatus
): status is OngoingReservationStatus =>
  (ONGOING_RESERVATION_STATUSES as readonly ReservationStatus[]).includes(
    status as ReservationStatus
  );

export const isFinalReservationStatus = (
  status: ReservationStatus
): status is FinalReservationStatus =>
  (FINAL_RESERVATION_STATUSES as readonly ReservationStatus[]).includes(status);

export const isCancelledReservationStatus = (
  status: ReservationStatus
): status is CancelledReservationStatus =>
  (CANCELLED_RESERVATION_STATUSES as readonly ReservationStatus[]).includes(
    status
  );

export const isFulfilledReservationStatus = (
  status: ReservationStatus
): status is FulfilledReservationStatus =>
  (FULFILLED_RESERVATION_STATUSES as readonly ReservationStatus[]).includes(
    status
  );

export type ReservationMode = 'delivery' | 'pickup' | 'kiosk' | 'curbside';

// Excludes kiosk, an in-store terminal mode that is never a shopper-facing choice.
export type ShopperReservationMode = Exclude<ReservationMode, 'kiosk'>;
